import { Dayjs } from "dayjs"

/**
 * Mirrors the `warrants_account_state` Postgres enum exposed by Hasura on the
 * be-financials source — used by the `warrants_accounts.status` column.
 */
export enum WarrantsAccountState {
  PENDING = "pending",
  WARRANT_PHASE_FIRST = "warrant_phase_first",
  WARRANT_PHASE_SECOND = "warrant_phase_second",
  WARRANT_PHASE_THIRD = "warrant_phase_third",
  WARRANT_PHASE_FOURTH = "warrant_phase_fourth",
  WARRANT_PHASE_FIFTH = "warrant_phase_fifth",
  WARRANT_PHASE_SIXTH = "warrant_phase_sixth",
  WARRANT_PHASE_SEVENTH = "warrant_phase_seventh",
  WARRANT_PHASE_EIGHTH = "warrant_phase_eighth",
  WARRANT_PHASE_NINTH = "warrant_phase_ninth",
  WARRANT_PHASE_TENTH = "warrant_phase_tenth",
  WARRANT_PHASE_COMPLETED = "warrant_phase_completed",
}

/** Who deleted the account, surfaced in the "Deleted" column. */
export enum WarrantsAccountDeletedBy {
  SYSTEM = "System",
  AGENT = "Agent",
  NONE = "",
}

export interface IWarrantsAccount {
  id: number
  accountNumber: string
  status: WarrantsAccountState
  pauseStart: Dayjs | null
  createdAt: Dayjs
  deletedAt: Dayjs | null
  deletedByAgentEmail: string | null

  /** `pause_start` is set. */
  readonly isPaused: boolean
  /**
   * Calculated "Deleted" column: 'System' when `deleted_at` is set, 'Agent'
   * when only `deleted_by_agent_email` is set, otherwise '' (not deleted).
   */
  readonly deletedBy: WarrantsAccountDeletedBy
  /** True when the account counts as deleted (system or agent). */
  readonly isDeleted: boolean
  /** The status enum value rendered for display, e.g. 'Warrant phase first'. */
  readonly statusDisplay: string
}
